import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Tooltip } from 'antd';
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import css from './styles.module.scss';

const Sort = ({ isLoading, handleChangeSort, activeSort, sortTypes, canDisable, className }) => {
  const { t } = useTranslation('sort');

  const changeSort = name => {
    const currentSort = sortTypes?.find(item => item.name === name);
    let nextSort = '';

    if (!canDisable) {
      nextSort = activeSort === currentSort.value[0] ? currentSort.value[1] : currentSort.value[0];
    } else {
      switch (activeSort) {
        case currentSort.value[0]:
          nextSort = currentSort.value[1];
          break;

        case currentSort.value[1]:
          nextSort = '';
          break;

        default:
          nextSort = currentSort.value[0];
          break;
      }
    }

    handleChangeSort(nextSort);
  };

  const renderArrow = sort => {
    if (sort.value.some(item => item === activeSort)) {
      const currentSort = sortTypes?.find(item => item.name === sort.name);
      const up = activeSort === currentSort.value[0] ? true : false;

      return (
        <div className={css['Sort-arrow-block']}>
          <Tooltip title={t(currentSort.type + (up ? ',asc' : ',desc'))} placement='topRight'>
            {up ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
          </Tooltip>
        </div>
      );
    }
  };

  const renderSort = useMemo(
    () =>
      sortTypes?.map((sort, index) => {
        return (
          <div
            key={index + sort.name}
            data-qa={`Sort-sortingBtn-${sort.name}`}
            className={classNames(css['Sort-point'], {
              [css['Sort-active']]: sort.value.some(item => item === activeSort),
            })}
            onClick={() => changeSort(sort.name)}
          >
            {sort.name}
            {renderArrow(sort)}
          </div>
        );
      }),
    [sortTypes]
  );

  return (
    <div className={classNames(css.Sort, { [css['Sort-loading']]: isLoading }, className)}>
      <div className={css['Sort-block']}>
        <div className={css['Sort-label']}>{t('sort')}</div>
        {renderSort}
      </div>
    </div>
  );
};

Sort.propTypes = {
  activeSort: PropTypes.string,
  isLoading: PropTypes.bool,
  handleChangeSort: PropTypes.func.isRequired,
  sortTypes: PropTypes.array.isRequired,
  className: PropTypes.string, // Если требуется переписать дефолтные стили
};

// Принимает в формате
// sortTypes = [
//   {
//     name: string, имя сортировки
//     value: [string, string], занчение сортировки, максимум 2 элемента
//     type: string, отвечает за тип подсказки для стрелочки
//   },
// ];

export default Sort;
